import * as types from './actionTypes';

export function setBlogBusinessAction (business) {
    return {type: types.SET_BLOG_BUSINESS, business}
}
